import { Link } from 'react-router-dom';

/**
 * The module eyebrow above a workspace card's title, as a link into that module.
 *
 * A workspace card is a summary; the natural next step from one is the module it
 * summarises, and the module name is already the label for exactly that. It is a
 * real anchor so it opens in a new tab on middle-click like any other link.
 */
export function CardModuleLink({
  module,
  href,
  editing = false,
}: {
  module: string;
  href: string;
  /** In edit mode the label is inert — navigating away would discard the draft layout. */
  editing?: boolean;
}) {
  if (editing) {
    return (
      <span className="truncate text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
        {module}
      </span>
    );
  }

  return (
    <Link
      to={href}
      // The header doubles as the drag handle in edit mode; stop the press from
      // starting a drag so a click reliably navigates.
      onPointerDown={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      className="truncate rounded-sm text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground transition-colors hover:text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      title={`Go to ${module}`}
    >
      {module}
    </Link>
  );
}
